import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPriorityTiers(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={150}
      height={118}
      fill="none"
      {...props}
    >
      <path
        fill="#D3A136"
        d="m3.145 13.502 10.63-5.848a1.24 1.24 0 0 1 1.2 0l10.63 5.848a1.245 1.245 0 0 1 .425 1.796L15.4 30.713a1.244 1.244 0 0 1-2.047 0L2.72 15.298a1.244 1.244 0 0 1 .425-1.796"
      />
      <path
        fill="#F7D685"
        d="m59 74 11.972-32h7.968L91 74h-8.671l-2.025-6.668H69.52L67.495 74zm12.325-12.8h7.218l-3.565-11.815h-.088z"
      />
      <path
        stroke="url(#PriorityTiers_svg__a)"
        strokeWidth={11}
        d="M67.064 14.787c4.383-4.383 11.49-4.383 15.873 0l1.253 1.255a22.23 22.23 0 0 0 15.715 6.509h.321c6.198 0 11.223 5.025 11.223 11.223v.32a22.22 22.22 0 0 0 6.509 15.716l1.255 1.253c4.383 4.384 4.383 11.49 0 15.873l-1.255 1.254a22.22 22.22 0 0 0-6.509 15.715v.32c0 6.2-5.025 11.224-11.223 11.224h-.32a22.23 22.23 0 0 0-15.716 6.509l-1.254 1.255c-4.383 4.383-11.49 4.383-15.873 0l-1.253-1.255a22.23 22.23 0 0 0-15.715-6.509h-.32c-6.2 0-11.224-5.025-11.224-11.223v-.32a22.23 22.23 0 0 0-6.509-15.716l-1.255-1.254c-4.383-4.383-4.383-11.49 0-15.873l1.255-1.253a22.23 22.23 0 0 0 6.509-15.715v-.32c0-6.2 5.025-11.224 11.223-11.224h.32a22.23 22.23 0 0 0 15.716-6.509z"
      />
      <defs>
        <linearGradient
          id="PriorityTiers_svg__a"
          x1={75}
          x2={75}
          y1={6}
          y2={112}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C649" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPriorityTiers);
export default ForwardRef;
